// extracted by mini-css-extract-plugin
export default {"grid":"About_grid__RyXcA","text":"About_text__5cvI5","high":"About_high__WtLu4"};